import type { FrameLogger } from "./logger";

export abstract class CrossmintFrameService {
	abstract name: string;
	abstract log_prefix: string;
	protected logger: FrameLogger;

	constructor(logger: FrameLogger) {
		this.logger = logger;
	}

	public async init(): Promise<void> {}

	/**
	 * Returns minimal safe debug information about the service state.
	 * NEVER include: keys, secrets, tokens, auth data, PII
	 *
	 * @returns Safe debug information as key-value pairs
	 */
	public safeDebugState?():
		| Record<string, unknown>
		| Promise<Record<string, unknown>>;
}
